// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimeEntry  {
    _originalTypeClassName = "Loom.BO.TimeEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimeEntry.translate = translateService;
}
this.Id = null;
this.ProjectAcronym = null;
this.WPName = null;
this.TaskName = null;
this.FormalTask = null;
this.ClickupTaskUrl = null;
this.TimeTrackedMins = null;
this.TimeTrackedHours = null;
this.TimeTrackedDays = null;
this.TimeTrackedPMs = null;
this.ReportedOn = null;
this.StartDate = null;
this.EndDate = null;
this.EmployeeFullName = null;
this.ClickUpId = null;
this.ListName = null;
this.EmployeeEmail = null;
this.Category = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ProjectAcronym:any;
WPName:any;
TaskName:any;
FormalTask:any;
ClickupTaskUrl:any;
TimeTrackedMins:any;
TimeTrackedHours:any;
TimeTrackedDays:any;
TimeTrackedPMs:any;
ReportedOn:any;
StartDate:any;
EndDate:any;
EmployeeFullName:any;
ClickUpId:any;
ListName:any;
EmployeeEmail:any;
Category:any;
Project:any;
WP:any;
Task:any;
Person:any;
Employee:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setWP = ($this, value) => {
var oldValue = $this.WP;
$this.WP = value;
if (value != null) {
}
}
static setTask = ($this, value) => {
var oldValue = $this.Task;
$this.Task = value;
if (value != null) {
}
}
static setPerson = ($this, value) => {
var oldValue = $this.Person;
$this.Person = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}

static GetTimeTrackedDays($this: any): any{return Joove.Common.safeNumber($this?.TimeTrackedHours) / Joove.Common.safeNumber(8.0);
}
static GetTimeTrackedHours($this: any): any{return Joove.Common.safeNumber($this?.TimeTrackedMins) / Joove.Common.safeNumber(60.0);
}
static GetTimeTrackedPMs($this: any): any{return Joove.Common.safeNumber($this?.TimeTrackedHours) / Joove.Common.safeNumber(143.3);
}
static MapTimeEntry(source: any,target: any): any{if ((source == null || target == null)) {throw Error("Source or Target cannot be null.");}
target.ProjectAcronym = source?.ProjectAcronym;
target.WPName = source?.WPName;
target.TaskName = source?.TaskName;
target.FormalTask = source?.FormalTask;
target.ClickupTaskUrl = source?.ClickupTaskUrl;
target.TimeTrackedMins = source?.TimeTrackedMins;
target.TimeTrackedHours = source?.TimeTrackedHours;
target.TimeTrackedDays = source?.TimeTrackedDays;
target.TimeTrackedPMs = source?.TimeTrackedPMs;
target.ReportedOn = source?.ReportedOn;
target.StartDate = source?.StartDate;
target.EndDate = source?.EndDate;
target.EmployeeFullName = source?.EmployeeFullName;
target.ClickUpId = source?.ClickUpId;
target.ListName = source?.ListName;
target.EmployeeEmail = source?.EmployeeEmail;
target.Category = source?.Category;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}